const INITIAL_STATE = {
    confirmations: [],
    confirmation: {},
    transmissions: [],
    physicalConfirmation: {},
    physicalConfirmationList: [],
    filter: {},
    receiptStorage: [],
    receipts: [],
    receiptIds: [],
    receiptsGroup: [],
    receiptsCimPallet: [],
    selectedTab: 0,
    printSelect: "L",
    labels: [],
    suppliers: [],
    partNumberQuantityList: [],
    partNumberQuantity: {},
    areaConversions: [],
    areaConversion: {},
    mvis: [],
    resourceReport: {},
    sheds: [],
    alternativeMdrPartnumber: {},
    alternativeMdrPartnumberPaged: {},
    qmePartNumber: {},
    qmePartNumberPaged: {}
};

export default function physicalConfirmationReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }
    switch (action.type) {
        case 'SET_ACTIVE_TAB': {
            return {
                ...state,
                selectedTab: action.activeTab,
            };
        }
        case 'SET_PARTNUMBERQUANTITY_LIST': {
            return {
                ...state,
                partNumberQuantityList: action.partNumberQuantityList
            };
        }
        case 'SET_PARTNUMBERQUANTITY':
            return {
                ...state,
                partNumberQuantity: action.partNumberQuantity,
            };
        case 'UPDATE': {
            const physicalConfirmationState = action.physicalConfirmation;
            let receiptState = {};
            Object.assign(receiptState, state.receipts);
            receiptState = physicalConfirmationState.receipts;
            return {
                ...state,
                receipts: receiptState,
                physicalConfirmation: physicalConfirmationState
            };
        }
        case 'UPDATE_LIST': {
            const physicalConfirmationList = action.physicalConfirmationList.physicalConfirmationList;
            let receiptState = {};
            Object.assign(receiptState, state.receipts);
            receiptState = action.physicalConfirmationList.receipts;
            return {
                ...state,
                receipts: receiptState,
                receiptIds: action.physicalConfirmationList.receiptIds,
                physicalConfirmationList: physicalConfirmationList
            };
        }
        case 'UPDATE_RECEIPT': {
            const receipts = [];
            Object.assign(receipts, state.receipts);
            const receipt = receipts.find((o) => o.id === action.receipt.id);
            if (receipt) {
                Object.assign(receipt, action.receipt);
            }
            return {
                ...state,
                receipts: receipts
            };
        }
        case 'UPDATE_LABELS': {
            return {
                ...state,
                labels: action.labels
            };
        }
        case 'SET_AREA_CONVERSION': {
            return {
                ...state,
                areaConversion: action.areaConversion
            };
        }
        case 'UPDATE_SUPPLIERS': {
            return {
                ...state,
                suppliers: action.suppliers
            };
        }
        case 'UPDATE_RECEIPT_MASSIVE_INDICATOR': {
            const receipts = [];
            Object.assign(receipts, state.receipts);
            const receipt = receipts.find((i) => { return i.id === action.id; });
            if (receipt !== undefined) {
                receipt.massiveReceiptIndicator = action.value;
            }
            return {
                ...state,
                receipts: receipts
            };
        }
        case 'UPDATE_RECEIPT_VISUAL_INDICATOR': {
            const receipts = [];
            Object.assign(receipts, state.receipts);
            const receipt = receipts.find((i) => { return i.id === action.id; });
            if (receipt !== undefined) {
                receipt.visualReceiptIndicator = action.value;
            }
            return {
                ...state,
                receipts: receipts
            };
        }
        case 'ADD_RECEIPT_GROUP': {
            const receipts = [];
            Object.assign(receipts, state.receiptsGroup);
            receipts.push(action.receipt);
            return {
                ...state,
                receiptsGroup: receipts
            };
        }
        case 'REMOVED_RECEIPT_GROUP': {
            let receipts = [];
            Object.assign(receipts, state.receiptsGroup);
            receipts = receipts?.filter((i) => i.id !== action.receipt.id);
            return {
                ...state,
                receiptsGroup: receipts
            };
        }
        case 'ADD_CIMPALLET': {
            const receipts = [];
            Object.assign(receipts, state.receiptsCimPallet);
            receipts.push(action.receipt)

            return {
                ...state,
                receiptsCimPallet: receipts
            };
        }
        case 'REMOVED_CIMPALLET': {
            let receipts = [];
            Object.assign(receipts, state.receiptsCimPallet);
            receipts = receipts?.filter((i) => i.id !== action.receipt.id);
            return {
                ...state,
                receiptsCimPallet: receipts
            };
        }
        case 'UPDATE_SMALL_PARTS_CHECKED': {
            const receiptItem = [];
            Object.assign(receiptItem, state.receipts);
            const item = receiptItem?.find((i) => { return i.id === action.receiptId; });
            if (item !== undefined) {
                item.checked = action.value;
            }

            return {
                ...state,
                receipts: receiptItem,
            };
        }
        case 'UPDATE_TRANSMISSIONS': {
            return {
                ...state,
                transmissions: action.transmissions,
            };
        }
        case 'UPDATE_RECEIPT_DATE': {
            const receiptItem = {};
            Object.assign(receiptItem, state.receipt);

            const item = receiptItem?.receipts?.find((i) => { return i.partNumberCode === action.partnumberCode; });
            if (item !== undefined) {
                item[action.key] = action.value;
            }

            return {
                ...state,
                receipt: receiptItem,
            };
        }
        case 'RESET_CONFIRMATION': {
            return {
                ...state,
                confirmation: INITIAL_STATE.confirmation,
            };
        }
        case 'RESET_RECEIPT_GROUP': {
            return {
                ...state,
                receiptsGroup: INITIAL_STATE.receiptsGroup,
            };
        }
        case 'RESET_CIMPALLET': {
            return {
                ...state,
                receiptsCimPallet: INITIAL_STATE.receiptsCimPallet,
            };
        }
        case 'CREATE_CONFIRMATION':
            return {
                ...state,
                confirmation: action.confirmation,
            };
        case 'INSERT_NEW_CONFIRMATION':
            return {
                ...state,
                confirmations: [...state.confirmations, action.confirmation],
            };
        case 'UPDATE_RECEIPT_STORAGE': {
            return {
                ...state,
                receiptStorage: action.receiptStorage
            };
        }
        case 'DECREASE_RECEIPT_BALANCE': {
            let receiptItem = [];
            Object.assign(receiptItem, state.receipts);
            const item = receiptItem?.find((i) => { return i.partNumberCode === action.partNumberCode; });
            if (item) {
                item.balance -= action.value;
                if (item.qtPartnumbers && item.qme > 0) {
                    item.qtPartnumbers = item.balance / item.qme;
                }
            }
            return {
                ...state,
                receipts: receiptItem,
            };
        }
        case 'SET_PRINT_SELECT':
            return {

                ...state,
                printSelect: action.printSelect,
            };
        case 'SET_FILTER':
            return {
                ...state,
                filter: action.filter,
            };
        case 'CLEAR_PRINT_SELECT':
            return {
                ...state,
                printSelect: INITIAL_STATE.printSelect,
            };
        case 'SET_AREA_CONVERSIONS': {
            return {
                ...state,
                areaConversions: action.areaConversions
            };
        }
        case 'UPDATE_MVIS': {
            let mvisState = [];
            Object.assign(mvisState, action.mvis);
            return {
                ...state,
                mvis: mvisState
            };
        }
        case 'SET_RESOURCE_REPORT': {
            return {
                ...state,
                resourceMvi: action.resourceReport,
            };
        }
        case 'LIST_SHEDS': {
            return {
                ...state,
                sheds: action.shedList
            };
        }
        case 'SET_ALTERNATIVE_MDR_PARTNUMBER': {
            return {
                ...state,
                alternativeMdrPartnumber: action.alternativeMdrPartnumber
            };
        }
        case 'SET_ALTERNATIVE_MDR_PARTNUMBER_PAGED': {
            return {
                ...state,
                alternativeMdrPartnumberPaged: action.alternativeMdrPartnumberPaged
            };
        }
        case 'SET_QME_PARTNUMBER': {
            return {
                ...state,
                qmePartNumber: action.qmePartNumber
            };
        }
        case 'SET_QME_PARTNUMBER_PAGED': {
            return {
                ...state,
                qmePartNumberPaged: action.qmePartNumberPaged
            };
        }
        case 'CLEAR': {
            return {
                ...state,
                confirmations: INITIAL_STATE.confirmations,
                confirmation: INITIAL_STATE.confirmation,
                transmissions: INITIAL_STATE.transmissions,
                physicalConfirmation: INITIAL_STATE.physicalConfirmation,
                receiptStorage: INITIAL_STATE.receiptStorage,
                receipts: INITIAL_STATE.receipts,
                receiptIds: INITIAL_STATE.receiptIds,
                selectedTab: INITIAL_STATE.selectedTab,
                receiptsGroup: INITIAL_STATE.receiptsGroup,
                receiptsCimPallet: INITIAL_STATE.receiptsCimPallet,
                filter: INITIAL_STATE.filter,
                physicalConfirmationList: INITIAL_STATE.physicalConfirmationList,
                alternativeMdrPartnumberPaged: INITIAL_STATE.alternativeMdrPartnumberPaged,
                alternativeMdrPartnumber: INITIAL_STATE.alternativeMdrPartnumber
            };
        }
        default:
            return state;
    }
}
